import React from "react";
import axios from "axios";
import LinearProgress from "@mui/material/LinearProgress";

import "./Products.style.scss";
import Product from "../../components/product/Product";
import { ProductListContext } from "../../contexts/ProductListContext";
import { GetProductsResponse, ProductObjType } from "../../types/products";
import { getData } from "../../utils/app-service";

export default function Products() {
  const { products, updateProducts, loading, setLoading, clearFilters } =
    React.useContext(ProductListContext);

  React.useEffect(() => {
    fetchData();
  }, [clearFilters]);

  const fetchData = () => {
    setLoading(true);
    getData(

      "https://ai-retail-genai-kdp-api.azurewebsites.net/copilot",

      {

        query: `saohfsqfijsqgfqi`,

        user_id: "uuu",

      }

    )
      .then((response) => {
        updateProducts(response?.data?.products);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  return (
    <>
      {loading ? (
        <LinearProgress sx={{ flex: 1 }} />
      ) : (
        <div className="card-grid">
          {products &&
            products.map((product: ProductObjType) => (
              <Product key={product.productId} {...product} />
            ))}
        </div>
      )}
    </>
  );
}
